import { Info, X } from "lucide-react";

type PinningDisclaimerProps = {
  compact?: boolean;
  onDismiss: () => void;
};

export function PinningDisclaimer({ compact = false, onDismiss }: PinningDisclaimerProps) {
  return (
    <div
      className="mb-2 flex items-center gap-2 rounded-lg bg-purple-200 px-3 py-2"
      data-testid="pinning-disclaimer"
    >
      <Info className={`shrink-0 text-gray-900 ${compact ? "size-5" : "size-6"}`} />
      <p className="m-0 flex-1 text-xs leading-relaxed text-gray-900">
        {compact
          ? "Our design team makes edits after checkout."
          : "Our AI helps gather your instructions \u2014 but a real human artist will complete the edits after checkout. We\u2019ll email you a proof to approve before your shirts go to print."}
      </p>
      <button
        type="button"
        className="shrink-0 cursor-pointer rounded border-none bg-transparent text-gray-700 hover:text-gray-900"
        onClick={onDismiss}
        aria-label="Dismiss disclaimer"
        data-testid="pinning-disclaimer-dismiss"
      >
        <X className={`${compact ? "size-5" : "size-6"}`} />
      </button>
    </div>
  );
}
